import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let ClassService = {};

((ClassService) =>
{
  ClassService.getClasses = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/classes"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  ClassService.createClass = function(schoolKey, className)
  {
    return request.post({
      url:  utils.getServiceUrl("/classes"),
      cache: false,
      data: {
        name: className,
        "school-key": schoolKey
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  ClassService.updateClass = function(classKey, schoolKey, className)
  {
    return request.put({
      url:  utils.getServiceUrl("/classes/" + classKey + "/"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key : classKey,
        schoolKey : schoolKey,
        name: className
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  ClassService.deleteClass = function(classKey)
  {
    return request.delete({
      url:  utils.getServiceUrl("/classes/" + classKey),
      cache: false
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  ClassService.getStudents = function(classKey)
  {
    return request.get({
      url:  utils.getServiceUrl("/classes/" + classKey + "/students"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };
})(ClassService);

module.exports = ClassService;



// WEBPACK FOOTER //
// ./app/js/services/class-service.js